import { useApp } from '@/hooks/use-app-context';
import { isCollector } from '@/components/layout/header/navigation-registry';
import type { ContributorWorkspaceCopy } from './workspace-copy.types';

/**
 * The labels of the one authenticated workspace. A collector works in the same
 * shell as any contributor, with the collection sections added and the space
 * named after their job, so there is a single place to be and a single name
 * for it.
 */
export function useWorkspaceCopy(): ContributorWorkspaceCopy {
  const { t, user } = useApp();
  const copy = t.getPaidPage;
  const collects = isCollector(user);

  return {
    title: collects ? copy.workspaceCollectionTitle : copy.workspaceTitle,
    earnings: copy.workspaceEarnings,
    earningsDescription: copy.workspaceEarningsDescription,
    overview: copy.workspaceOverview,
    overviewDescription: copy.workspaceOverviewDescription,
    test: copy.workspaceTest,
    testDescription: copy.workspaceTestDescription,
    requests: copy.workspaceRequests,
    requestsDescription: copy.workspaceRequestsDescription,
    contracts: copy.workspaceContracts,
    pendingContracts: copy.workspacePendingContracts,
    pendingContractsDescription: copy.workspacePendingContractsDescription,
    signedContracts: copy.workspaceSignedContracts,
    signedContractsDescription: copy.workspaceSignedContractsDescription,
    collection: collects
      ? {
          label: copy.workspaceCollection,
          sections: {
            dashboard: {
              label: copy.workspaceCollectionDashboard,
              description: copy.workspaceCollectionDashboardDescription,
            },
            profiles: {
              label: copy.workspaceCollectionProfiles,
              description: copy.workspaceCollectionProfilesDescription,
            },
            contributions: {
              label: copy.workspaceCollectionContributions,
              description: copy.workspaceCollectionContributionsDescription,
            },
            'initial-audio': {
              label: copy.workspaceCollectionInitialAudio,
              description: copy.workspaceCollectionInitialAudioDescription,
            },
            chatbot: {
              label: copy.workspaceCollectionAssistant,
              description: copy.workspaceCollectionAssistantDescription,
            },
            guidelines: {
              label: copy.workspaceCollectionGuidelines,
              description: copy.workspaceCollectionGuidelinesDescription,
            },
          },
        }
      : null,
  };
}
